import { compose, withProps, onlyUpdateForKeys } from 'recompose';
import { withRouter } from 'react-router-dom';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import * as React from 'react';
import RolesCreateForm from '@modules/roles-create/RolesCreateForm';
import WithClassname from '@components/hoc/withClassname/WithClassname';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const rolesCreateUrl = '/metropolis/api/roles';
export const rolesCreateLabel = 'Vytvoření role';
export const rolesCreatePath = '/administration/roles/create';
export const rolesCreateGridName = 'RolesCreateGrid';
export const RolesCreateGrid = compose(
  withRouter,
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: rolesCreateLabel }]),
  withColumns(Agenda.ROLES_CREATE),
  withProps(({ columns }) => ({
    name: rolesCreateGridName,
    url: rolesCreateUrl,
    Form: RolesCreateForm,
    dialog: false,
    gridProps: {
      columns,
      locale: 'cz',
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      adding: true,
      filtering: false,
      sort: 'name',
      pageSize: 50,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.ROLES_CREATE} />
    }
  })),
  withAdditionalProps,
  WithClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/roles-create/RolesCreateGrid.tsx